import { ISalesQueryParams } from 'gen/ApiClient';

export const SalesParamsExclusions: (keyof ISalesQueryParams)[] = ['searchMode'];
